export default "__VITE_ASSET__7Sb32z$W__"